import { animateCamera } from "../../animations/animateCamera";
import { useThree } from "@react-three/fiber";
import { useEffect } from "react";
import { useRouter } from "next/router";

const ChangeCameraFiberComponent = () => {
  const { query } = useRouter();
  const { camera } = useThree();

  useEffect(() => {
    if (query.id) return;
    animateCamera(camera);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);
  return <mesh></mesh>;
};

export default ChangeCameraFiberComponent;
